module.exports = __webpack_public_path__ + "media/医院.dd8184b5.wav";